import {
  FETCH_TREE,
  FETCH_SOMETHING,
  SET_SOMETHING,
  SET_PRID,

  FETCH_IMMEDIATE_FAMILY,
  FETCH_LEGEND_DESCRIPTIONS,
  FETCH_MORE,
  FETCH_PRUNES,
  FETCH_PROFILES,
  FLUSHALLCALLBACKFORFETCHPROFILES,
  RELEASEQUEUEFETCHEDPROFILESDATA,
  RELEASEQUEUEOFFETCHEDNODEOBJPICS,
  NOTIFYPROFILEADD,
  UPDATEMATCHCOUNTS,
  CHECKQUEUEFETCHEDNODEOBJPIC,
  FETCH_FLIPDATA,
  UNSET_FLIPDATA,
  UNSET_NODEOBJ_PROP,
  UNSET_NODEOBJ_PIC,
  UNSET_NODEOBJ_GEDCOM,
  SET_NODEOBJ_PIC,
  STORE_CUSTOM_RECENTER_IN_DUALPEDIGREE,
  DESIGNATE_DROPTARGET,
  UNDESIGNATE_DROPTARGET,
  FETCH_TREE_ERROR,
  POST_INVITE,
  POST_PREFERENCES,
  POST_POSTER,
  GETUNION_ID_FANCHART,
  UPLOADPHOTO,
  POSTREDUX_PREFERENCES,
  POST_PREFERENCESCHARTTYPE,
  POST_CHOSENUNIONID,
  POST_ADD_EXISTING,
  ADD_FLOATER,
  REMOVE_FLOATER,
  FETCH_PREFERENCES,
  SET_UNIONS,
  SET_IS_LARGETREE,
  SET_BRANCHES,
  SET_NODES_OBJS,
  SET_FAN_CHART_DATA,
  SET_FANCHART_UNIQUE_CHARS,
  SET_WIDTHS_NAMES_FOR_FANCHART,
  SET_NODES_OBJS_BY_NODE,
  SET_TEST,
  SET_COUNTOF,
  SET_NODEOBJSBYRANGE,
  SET_EDGES,
  SET_FOCUSNODE,
  SET_CID_GRPS,
  SET_FIRSTTREEMATCHCOUNTNODE,
  SET_FIRSTRECORDMATCHCOUNTNODE,
  SET_FIRSTMALEGHOSTNODE,
  SET_FIRSTFEMALEGHOSTNODE,
  SET_FIRSTTREEMATCHNODE,
  SET_FIRSTDEADNODE,
  SET_FIRSTRECORDMATCHNODE,
  SET_FIRSTSMARTMATCHNODE,
  SET_FIRSTCYCLEMASTERNODE,
  SET_FIRSTMULTIPLEPARENTNODE,
  SET_FIRSTCONFLICTNODE,
  SET_FIRSTDNANODE,

  FIRSTEDITNODE,
  FIRSTEMAILREQUESTNODE,
  SET_FIRSTINCONSISTENTENCYNODE,
  SET_FIRSTMERGEPENDINGNODE,
  SET_FIRSTAPPEAR05NODE,
  SET_FIRSTAPPEAR06NODE,
  SET_FIRSTAPPEAR07NODE,
  SET_FIRSTAPPEAR08NODE,
  SET_FIRSTAPPEAR09NODE,
  SET_NUMOFGENERATIONS,

  SET_CANVAS_HEIGHT_TOP,
  SET_PROFILE_OBJS,
  STOP_INFLIGHT_SAGAS,
  SET_VIEWPORT,
  SET_PROGRESS,
  SET_CANVAS_WIDTH,
  SET_CANVAS_HEIGHT,
  SET_FLIPDATA,
  SET_PREFERENCES,
  SET_FLOATERS,
  SET_LEGEND_DESCRIPTIONS,
  SET_RESOLVE,
  POST_RESOLVE,
  FETCH_FLOATERS,
  CANCEL_SPAWNED_FETCHPROFILES,
} from '../library/constants';

export function set_something(obj) {
  // console.log('Action: set_something');
  return {
    type: SET_SOMETHING,
    obj,
  };
}

export function setPrId(prId, fromWhere) {
  return {
    type: SET_PRID,
    prId,
  };
}

export function fetch_something(fetchSomeParam) {
  // console.log('Action: fetch_something');
  const obj = {
    type: FETCH_SOMETHING,
  };
  return obj;
}

export function fetchTreeError(error) {
  return {
    type: FETCH_TREE_ERROR,
    error,
  };
}

export function setFlipData(flipData) {
  return {
    type: SET_FLIPDATA,
    flipData,
  };
}

export function setPreferences(preferencesData) {
  // console.log(`preferencesData: `, JSON.stringify(preferencesData, null, 2));
  return {
    type: SET_PREFERENCES,
    preferencesData,
  };
}

export function fetchTree(fetchTreeParam) {

  let obj = {
    type: FETCH_TREE,
    callback: (fetchTreeParam && fetchTreeParam.callback ? fetchTreeParam.callback: undefined),
    prIdToTeleport: (fetchTreeParam && fetchTreeParam.prIdToTeleport ? fetchTreeParam.prIdToTeleport: undefined),
  };

  if( typeof(fetchTreeParam && fetchTreeParam.unionId) !== 'undefined' ) obj = {...obj, unionId: fetchTreeParam.unionId }
  if( typeof(fetchTreeParam && fetchTreeParam.fromWhere) !== 'undefined' ) obj = {...obj, fromWhere: fetchTreeParam.fromWhere }

  return obj;
}

export function fetchImmediateFamily({focusPrId, focusNodeId, focusGender, afterFetch, forWhat}) {
  return {
    type: FETCH_IMMEDIATE_FAMILY,
    focusPrId,
    focusNodeId,
    focusGender,
    afterFetch,
    forWhat,
  };
}

export function fetchLegendDescriptions({focusPrId}) {
  return {
    type: FETCH_LEGEND_DESCRIPTIONS,
    focusPrId,
  };
}

export function postInvite({email, prId, node, callbackWhen, callback}) {
  return {
    type: POST_INVITE,
    email,
    prId,
    node,
    callbackWhen,
    callback,
  };
}

export function postPreferences({ ancestors,  descendants, hide_public_warning, show_guide, guide_page, show_ancestors, hide_hot_match_prompt, hide_record_match_prompt, skipReloadCanvasTree, styles, callback }) {
  // console.log(`{}: `, JSON.stringify({ ancestors,  descendants, hide_public_warning, show_guide, hide_hot_match_prompt, hide_record_match_prompt, skipReloadCanvasTree, callback }, null, 2));
  return {
    type: POST_PREFERENCES,
      ancestors,
      descendants,
      hide_public_warning,
      hide_hot_match_prompt,
      hide_record_match_prompt,
      skipReloadCanvasTree,
      callback,
      show_guide,
      guide_page,
      show_ancestors,
      styles,
  };
}

export function getUnionIdForFanChart({ focusPrId, callFetchTree}) {
  return {
    type: GETUNION_ID_FANCHART,
    focusPrId,
    callFetchTree,
  };
}

export function postPoster({ action, unionId, tpId, prId, focusPrId, node, posterData, custom, frameStyle, backgroundTextureFileName, titleBorder, fontFamily, includeDate,  whichChildrenNode, searchterm, titleName, profileName, callFetchTree, callSetBackgroundTextureDualPedigree,  callReloadCanvasTree}) {
  // console.log(`action: `, action);
  return {
    type: POST_POSTER,
    action,
    unionId,
    tpId,
    prId,
    focusPrId,
    node,
    custom,
    posterData,
    frameStyle,
    backgroundTextureFileName,
    titleBorder,
    fontFamily,
    includeDate,
    whichChildrenNode,
    searchterm,
    titleName,
    profileName,
    callFetchTree,
    callSetBackgroundTextureDualPedigree,
    callReloadCanvasTree,
  };
}

export function uploadphoto({ node, title, file, prId, uploadPhotoCallback}) {
  return {
    type: UPLOADPHOTO,
    node,
    title,
    file,
    prId,
    uploadPhotoCallback,
  };
}

export function postreduxpreferences({ guide_page, callback }) {
  // console.log(`{}: `, JSON.stringify({ ancestors,  descendants, hide_public_warning, show_guide, hide_hot_match_prompt, hide_record_match_prompt, skipReloadCanvasTree, callback }, null, 2));
  return {
    type: POSTREDUX_PREFERENCES,
      callback,
      guide_page,
  };
}

export function postPreferencesChartType({ chart_type, callback }) {
  return {
    type: POST_PREFERENCESCHARTTYPE,
      chart_type,
      callback,
  };
}

export function postChosenUnionId({ chosenUnionId, childPrId}) {
  return {
    type: POST_CHOSENUNIONID,
      chosenUnionId,
      childPrId,
  };
}

export function postAddExisting({ floater_profile_id, focusPrid, rel, dropOnPrId, marriageId, callNotification }) {
  return {
    type: POST_ADD_EXISTING,
      floater_profile_id,
      focusPrid,
      rel,
      dropOnPrId,
      marriageId,
      callNotification,
  };
}

export function addFloater({prId, callbackAfterAddedFloater}) {
  return {
    type: ADD_FLOATER,
      prId,
      callbackAfterAddedFloater,
  };
}

export function removeFloater({prId, showFloaterPanel, redraw}) {
  return {
    type: REMOVE_FLOATER,
      prId,
      redraw,
      showFloaterPanel,
  };
}


export function fetchPreferences({callbackAfterPreferenceFetch}) {
  return {
    type: FETCH_PREFERENCES,
    callbackAfterPreferenceFetch,
  };
}

export function fetchMore({newProfilesObj, newPrunesObj, prefetch, postfetch}) {
  return {
    type: FETCH_MORE,
    newProfilesObj,
    newPrunesObj,
    prefetch,
    postfetch,
  };
}

export function fetchProfiles({
    newProfilesObj,
    prefetch,
    postfetch,
    releaseQueueOfFetchedProfilesData,
    setAllProfilesIsFetched,
    callbackAllowComponentUpdate,
    callbackSetProgressBar,
    callRedraw,
  }) {
/*
        console.log(`%cFETCHPROFILES: `, [
        'color: white',
        'background: green',
        'font-size: 14px',
        'border: 5px solid red',
        'padding: 10px',
        ].join(';'));
*/

  return {
    type: FETCH_PROFILES,
    newProfilesObj,
    prefetch,
    postfetch,
    releaseQueueOfFetchedProfilesData,
    setAllProfilesIsFetched,
    callbackAllowComponentUpdate,
    callbackSetProgressBar,
    callRedraw,
  };
}

export function flushallcallbackforfetchprofiles() {
  return {
    type: FLUSHALLCALLBACKFORFETCHPROFILES
  };
}

export function releaseQueueFetchedProfilesData() {
  return {
    type: RELEASEQUEUEFETCHEDPROFILESDATA,
  };
}


export function releaseQueueOfFetchedNodeobjPics() {
  return {
    type: RELEASEQUEUEOFFETCHEDNODEOBJPICS,
  };
}

export function notifyProfileAdd({node}) {
  return {
    type: NOTIFYPROFILEADD,
    node,
  };
}

export function updateMatchCounts({node, matchData, tmn, rmn, firstMatchCallback}) {
  return {
    type: UPDATEMATCHCOUNTS,
    node,
    matchData,
    tmn,
    rmn,
    firstMatchCallback,
  };
}

export function checkqueuefetchednodeobjpic() {
  return {
    type: CHECKQUEUEFETCHEDNODEOBJPIC,
  };
}

export function fetchPrunes({newPrunesObj, prefetch, postfetch, fromWhere}) {
  return {
    type: FETCH_PRUNES,
    newPrunesObj,
    prefetch,
    postfetch,
    fromWhere,
  };
}

export function fetchFlipData({pr_id, node, callSetNodeObjPic, callback}) {
  return {
    type: FETCH_FLIPDATA,
    pr_id,
    node,
    callSetNodeObjPic,
    callback,
  };
}

export function unsetFlipData() {
  return {
    type: UNSET_FLIPDATA,
  };
}

export function designateDropTarget(node) {
  return {
    type: DESIGNATE_DROPTARGET,
    node,
  };
}

export function undesignateDropTarget(node) {
  return {
    type: UNDESIGNATE_DROPTARGET,
    node,
  };
}

export function unsetNodeObjProp({node, nodes, all}) {
  return {
    type: UNSET_NODEOBJ_PROP,
    node,
    nodes,
    all,
  };
}

export function setNodeObjPic({node, imgObj, delayInMilisec}) {
  return {
    type: SET_NODEOBJ_PIC,
    node,
    imgObj,
    delayInMilisec,
  };
}

export function storeCustomRecenterInDualpedigree({node, custom}) {
  return {
    type: STORE_CUSTOM_RECENTER_IN_DUALPEDIGREE,
    node,
    custom
  };
}

export function unsetNodeObjPic({node, all}) {
  return {
    type: UNSET_NODEOBJ_PIC,
    node,
    all,
  };
}

export function unsetNodeObjGedcom({node}) {
  return {
    type: UNSET_NODEOBJ_GEDCOM,
    node,
  };
}


// export function fetchFlipMoreFilter({prId, node}) {
//   return {
//     type: FETCH_FLIPMOREFILTER,
//     prId,
//     node,
//   };
// }

export function setNodesObjs(nodeObjs, fromWhere) {
  // console.log(`fromWhere: `, fromWhere);
  return {
    type: SET_NODES_OBJS,
    nodeObjs,
    fromWhere,
  };
}

export function setFanChartData(fanChartData, fromWhere) {
  return {
    type: SET_FAN_CHART_DATA,
    fanChartData,
    fromWhere,
  };
}

export function setFanChartUniqueChars(uniqueFanChartChars, fromWhere) {
  return {
    type: SET_FANCHART_UNIQUE_CHARS,
    uniqueFanChartChars,
    fromWhere,
  };
}

export function setWidthsNamesForFanchart(hashWidthsNamesForFanchart, fromWhere) {
  return {
    type: SET_WIDTHS_NAMES_FOR_FANCHART,
    hashWidthsNamesForFanchart,
    fromWhere,
  };
}

export function setNodesObjsByNode(nodeObj, node, fromWhere) {
  return {
    type: SET_NODES_OBJS_BY_NODE,
    nodeObj,
    node,
    fromWhere,
  };
}

export function setTest(foo, key, fromWhere) {
  return {
    type: SET_TEST,
    foo,
    key,
    fromWhere,
  };
}

export function set_nodeobjsbyrange(nodeObjsByRange, fromWhere) {
  return {
    type: SET_NODEOBJSBYRANGE,
    nodeObjsByRange,
    fromWhere,
  };
}

export function set_countOf(countOf, fromWhere) {
  return {
    type: SET_COUNTOF,
    countOf,
    fromWhere,
  };
}

export function setEdges(edges, fromWhere) {
  return {
    type: SET_EDGES,
    edges,
    fromWhere,
  };
}

export function set_focusnode(focusNode, fromWhere) {
  return {
    type: SET_FOCUSNODE,
    focusNode,
    fromWhere,
  };
}

export function set_cid_grps(cidsGrps, fromWhere) {
  return {
    type: SET_CID_GRPS,
    cidsGrps,
    fromWhere,
  };
}

export function set_firstTreeMatchCountNode(firstTreeMatchCountNode, fromWhere) {
  return {
    type: SET_FIRSTTREEMATCHCOUNTNODE,
    firstTreeMatchCountNode,
    fromWhere,
  };
}

export function set_firstRecordMatchcCountNode(firstRecordMatchCountNode, fromWhere) {
  return {
    type: SET_FIRSTRECORDMATCHCOUNTNODE,
    firstRecordMatchCountNode,
    fromWhere,
  };
}

export function set_firstFemaleGhostNode(firstFemaleGhostNode, fromWhere) {
  return {
    type: SET_FIRSTFEMALEGHOSTNODE,
    firstFemaleGhostNode,
    fromWhere,
  };
}

export function set_firstMaleGhostNode(firstMaleGhostNode, fromWhere) {
  return {
    type: SET_FIRSTMALEGHOSTNODE,
    firstMaleGhostNode,
    fromWhere,
  };
}

export function set_firstTreeMatchNode(firstTreeMatchNode, fromWhere) {
  return {
    type: SET_FIRSTTREEMATCHNODE,
    firstTreeMatchNode,
    fromWhere,
  };
}

export function set_firstDeadNode(firstDeadNode, fromWhere) {
  return {
    type: SET_FIRSTDEADNODE,
    firstDeadNode,
    fromWhere,
  };
}

export function set_firstRecordMatchNode(firstRecordMatchNode, fromWhere) {
  return {
    type: SET_FIRSTRECORDMATCHNODE,
    firstRecordMatchNode,
    fromWhere,
  };
}

export function set_firstSmartMatchNode(firstSmartMatchNode, fromWhere) {
  return {
    type: SET_FIRSTSMARTMATCHNODE,
    firstSmartMatchNode,
    fromWhere,
  };
}

export function set_firstCycleMasterNode(firstCycleMaster, fromWhere) {
  return {
    type: SET_FIRSTCYCLEMASTERNODE,
    firstCycleMaster,
    fromWhere,
  };
}

export function set_firstMultipleParentNode(firstMultipleParentNode, fromWhere) {
  return {
    type: SET_FIRSTMULTIPLEPARENTNODE,
    firstMultipleParentNode,
    fromWhere,
  };
}

export function set_firstConflictNode(firstConflictNode, fromWhere) {
  return {
    type: SET_FIRSTCONFLICTNODE,
    firstConflictNode,
    fromWhere,
  };
}

export function set_firstDNANode(set_firstDNANode, fromWhere) {
  return {
    type: SET_FIRSTDNANODE,
    set_firstDNANode,
    fromWhere,
  };
}


export function set_firstEditNode(firstEditNode, fromWhere) {
  return {
    type: FIRSTEDITNODE,
    firstEditNode,
    fromWhere,
  };
}

export function set_firstEmailRequestNode(firstEmailRequestNode, fromWhere) {
  return {
    type: FIRSTEMAILREQUESTNODE,
    firstEmailRequestNode,
    fromWhere,
  };
}

export function set_firstInconsistentencyNode(firstInconsistentencyNode, fromWhere) {
  return {
    type: SET_FIRSTINCONSISTENTENCYNODE,
    firstInconsistentencyNode,
    fromWhere,
  };
}

export function set_firstMergePendingNode(firstMergePendingNode, fromWhere) {
  return {
    type: SET_FIRSTMERGEPENDINGNODE,
    firstMergePendingNode,
    fromWhere,
  };
}
export function set_firstAppear05Node(firstAppear05Node, fromWhere) {
  return {
    type: SET_FIRSTAPPEAR05NODE,
    firstAppear05Node,
    fromWhere,
  };
}

export function set_firstAppear06Node(firstAppear06Node, fromWhere) {
  return {
    type: SET_FIRSTAPPEAR06NODE,
    firstAppear06Node,
    fromWhere,
  };
}

export function set_firstAppear07Node(firstAppear07Node, fromWhere) {
  return {
    type: SET_FIRSTAPPEAR07NODE,
    firstAppear07Node,
    fromWhere,
  };
}

export function set_firstAppear08Node(firstAppear08Node, fromWhere) {
  return {
    type: SET_FIRSTAPPEAR08NODE,
    firstAppear08Node,
    fromWhere,
  };
}

export function set_firstAppear09Node(firstAppear09Node, fromWhere) {
  return {
    type: SET_FIRSTAPPEAR09NODE,
    firstAppear09Node,
    fromWhere,
  };
}

export function set_numOfGenerations(numOfGenerations, fromWhere) {

  return {
    type: SET_NUMOFGENERATIONS,
    numOfGenerations,
    fromWhere,
  };
}


export function setProfileObjs(profileObjs, fromWhere) {
  return {
    type: SET_PROFILE_OBJS,
    profileObjs,
    fromWhere,
  };
}

export function stop_inflight_sagas() {
  return {
    type: STOP_INFLIGHT_SAGAS
  };
}

export function setViewport({top, right, bottom, left}) {
  const viewport = {top, right, bottom, left};
  return {
    type: SET_VIEWPORT,
    viewport,
  };
}

export function setProgressLoaded(loaded) {
  return {
    type: SET_PROGRESS,
    progress: {
      loaded,
      show: true,
    },
  };
}

export function setProgressBarShow(show) {
  return {
    type: SET_PROGRESS,
    progress: {
      loaded: ( show ? 0: 100),
      show
    },
  };
}

export function setReduxCanvasHeightTop({top, height}) {
  return {
    type: SET_CANVAS_HEIGHT_TOP,
    canvas: {top, height},
  };
}

export function setCanvasWidth({width}) {
  return {
    type: SET_CANVAS_WIDTH,
    canvas: {width},
  };
}

export function setCanvasHeight({height}) {
  return {
    type: SET_CANVAS_HEIGHT,
    canvas: {height},
  };
}

export function setUnions(unions) {
  return {
    type: SET_UNIONS,
    unions,
  };
}
export function set_is_largetree({isLargeTree, nodecount}) {
  return {
    type: SET_IS_LARGETREE,
    isLargeTree,
    nodecount,
  };
}

export function setBranches(branches) {
  return {
    type: SET_BRANCHES,
    branches,
  };
}


export function setFloaters({floaters}) {
  return {
    type: SET_FLOATERS,
    floaters,
  };
}


export function set_legend_descriptions(legendDescriptions) {
  return {
    type: SET_LEGEND_DESCRIPTIONS,
    legendDescriptions,
  };
}

export function setResolve({focusPrId, parents, siblings, children, partners}) {
  return {
    type: SET_RESOLVE,
    focusPrId,
    parents,
    partners,
    children,
    siblings,
  };
}

export function postResolve({focusPrId, parent, sibling, children, partner, closeResolveModal}) {
  return {
    type: POST_RESOLVE,
    focusPrId,
    parent,
    partner,
    children,
    sibling,
    closeResolveModal,
  };
}


// export function setDropOnNode(node) {
//   console.log(`node: `, node);
//   return {
//     type: SET_DROPON_NODE,
//     node,
//   };
// }


export function fetchFloaters({callbackWhenEverFloatersExist,  callbackWhenEverFloatersDontExist}) {
  return {
    type: FETCH_FLOATERS,
    callbackWhenEverFloatersExist,
    callbackWhenEverFloatersDontExist
  };
}

export function cancelAllSpawnedFetchProfiles() {
  return {
    type: CANCEL_SPAWNED_FETCHPROFILES,
  };
}
